import { render, staticRenderFns } from "./AltaNotasCreditoFiscales.vue?vue&type=template&id=764e0dfd"
import script from "./AltaNotasCreditoFiscales.vue?vue&type=script&lang=js"
export * from "./AltaNotasCreditoFiscales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports